<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">비밀번호 입력</p>
        <p>회원정보 조회, 수정을 위해 비밀번호를 입력하세요.</p>
      </li>
    </ul>
    <div class="password-input">
      <div class="pw-div">
        <input :type="!inputType ? 'password' : 'text'" id="password" v-model="pwd"
               class="input-style"  placeholder="비밀번호를 입력하세요" @keyup.enter="pwdCheckFunc">
        <div class="eyes" @click="inputType = !inputType">
          <img :class="{off: !inputType}" :src="imageSrc(!inputType ? 'off' : 'on')" alt="">
        </div>
      </div>
      <button class="login-btn" @click="pwdCheckFunc">비밀번호 확인</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  data() {
    return {
      inputType: false,
      pwd: null
    }
  },
  mounted () {
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/visibility_'+imgSrc+'.png');
    },
    async pwdCheckFunc() {
      const {data} = await this.$http.post('/user/check_password', {
        user_pw: this.pwd
      });
      if(data.success) {
        this.$emit("password", true);
      }
      if(!data.success){
        alert(data.message);
      }
    }
  }
}
</script>
